import ConfigService from './configurationService.js';
import axios from 'axios';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace AgelocService
 */
const dayMoisturizer = ["T1", "S1", "T2", "S2", "T3", "S3", "T5", "S5", "T6", "S6", "T7", "S7", "T9", "S9"];
const nightMoisturizer = ["K5", "Z5", "K6", "Z6", "K7", "Z7", "K8", "Z8"];
const serum1 = ["Q5X4", "Q6X4", "Q8X4", "Q5X9", "Q6X9", "Q8X9"];
const serum2 = ["R1", "R3", "R7"];
const dayAlpha = ["A", "Y", "C", "D", "E", "U", "G", "H", "J", "K", "L", "M", "N", "P"];
const nightAlpha = ["Z", "B", "X", "W", "V", "F", "T", "S"];
const numeric1 = ["7", "2", "9", "6", "3", "8"];
const numeric2 = ["3", "5", "8"];

const validCode = function (code) {
    return decodeCode(code).length == 5;
};

var decodeCode = function (code) {
    let agelocme = ConfigService.getMarketConfig().agelocme;

    if (code.length === 4) {
        return decodeNormalCode(code);
    } else if (code.length === 3 && agelocme.showCoreSolutions) {
        return decodeCoreCode(code)
    }
    return [];
};

var decodeNormalCode = function (code) {
    var returnArray = [];

    if (code.length == 4 && !isRetiredCode(code)) {
        try {
            var codeArray = code.split("");
            var thirdCode = serum1[numeric1.indexOf(codeArray[2])];

            returnArray[0] = dayMoisturizer[dayAlpha.indexOf(codeArray[0])];
            returnArray[1] = nightMoisturizer[nightAlpha.indexOf(codeArray[1])];
            returnArray[2] = thirdCode.substr(0, 2);
            returnArray[3] = thirdCode.substr(2, 4);
            returnArray[4] = serum2[numeric2.indexOf(codeArray[3])];

            //Check to see that none of the values are undefined
            for (var i = 0; i < 5; i++) {
                if (returnArray[i] == undefined) {
                    returnArray = [];
                }
            }
        } catch (err) {
            returnArray = [];
        }
    }

    return returnArray;
};

let calculateCode = function (assessmentData) {
    if (assessmentData.isCoreSolution) {
        return calculateCoreCode(assessmentData);
    } else {
        return calculateNormalCode(assessmentData);
    }
};

let calculateNormalCode = function (assessmentData) {
    let codesMap = getCodesMap(),
        decodedCode;

    if (assessmentData.changeSerums) {
        calcCR(assessmentData);
        calcLW(assessmentData);
        calcP(assessmentData);
    }
    if (assessmentData.changeDay) {
        calcDM(assessmentData);
    }
    if (assessmentData.changeNight) {
        calcNM(assessmentData);
    }

    let productCode = dayAlpha[dayMoisturizer.indexOf(assessmentData.DM)] + nightAlpha[nightMoisturizer.indexOf(assessmentData.NM)] +
        numeric1[serum1.indexOf(assessmentData.LC + assessmentData.PC)] + numeric2[serum2.indexOf(assessmentData.S2)];

    //Validate Code to show ERROR if invalid

    if (codesMap[productCode]) {
        productCode = codesMap[productCode];
        decodedCode = decodeCode(productCode);
        setDecodedSerums(assessmentData, decodedCode);
    } else {
        decodedCode = decodeCode(productCode);
    }
    if (decodedCode.length != 5) {
        productCode = "ERROR";
    }
    return productCode;
};

function setDecodedSerums(assessmentData, codes) {
    if (codes.length === 5) {
        assessmentData.DM = codes[0];
        assessmentData.NM = codes[1];
        assessmentData.LC = codes[2];
        assessmentData.PC = codes[3];
        assessmentData.S2 = codes[4];
    }
}

function calcCR(assessmentData) {
    assessmentData.CR = 0;
    if (assessmentData.age >= 40 && assessmentData.age < 60) {
        assessmentData.CR += 2;
    } else if (assessmentData.age >= 60) {
        assessmentData.CR += 3;
    } else {
        assessmentData.CR += 1;
    }

    if (assessmentData.somePollution || assessmentData.highPollution) {
        assessmentData.CR += 1;
    }

    if (assessmentData.skinSomeDull) {
        assessmentData.CR += 2;
    }
    if (assessmentData.skinVeryDull) {
        assessmentData.CR += 4;
    }

    if (assessmentData.skinSomeRough) {
        assessmentData.CR += 2;
    }
    if (assessmentData.skinRough) {
        assessmentData.CR += 4;
    }

    if (assessmentData.poreValue > 33 && assessmentData.poreValue <= 66) {
        assessmentData.CR += 2;
    }
    if (assessmentData.poreValue > 66) {
        assessmentData.CR += 4;
    }

    if (!assessmentData.environmentZero && !assessmentData.environmentOne && !assessmentData.environmentTwo) {
        assessmentData.CR += 1;
        //Don't allow CR Level 3 if daylight > 2 hours and no SPF in day moisturizer
        if (assessmentData.spfNo && assessmentData.CR > 2) {
            assessmentData.CR = 3;
        }
    }

    if (assessmentData.highSkinSensitivity || assessmentData.extremeSkinSensitivity || assessmentData.ahaStopped) {
        assessmentData.CR = 0;
    }


    if (assessmentData.CR <= 2) {
        assessmentData.S2 = "R1";
    } else if (assessmentData.CR > 2 && assessmentData.CR <= 4) {
        assessmentData.S2 = "R3";
    } else if (assessmentData.CR >= 5) {
        assessmentData.S2 = "R7";
    }
}

function calcLW(assessmentData) {
    assessmentData.LW = 0;
    //CALCULATE LINES/WRINKLES
    if (assessmentData.age >= 30 && assessmentData.age < 50) {
        assessmentData.LW += 1;
    }
    if (assessmentData.age >= 50 && assessmentData.age < 60) {
        assessmentData.LW += 2;
    }
    if (assessmentData.age >= 60 && assessmentData.age < 70) {
        assessmentData.LW += 3;
    }
    if (assessmentData.age >= 70) {
        assessmentData.LW += 4;
    }
    if (assessmentData.environmentThree || assessmentData.environmentFour) {
        assessmentData.LW += 1;
    }
    if (!assessmentData.environmentZero && !assessmentData.environmentOne && !assessmentData.environmentTwo && !assessmentData.environmentThree && !assessmentData.environmentFour) {
        assessmentData.LW += 2;
    }
    var wrinkles = (assessmentData.noseWrinkleValue + assessmentData.eyeWrinkleValue + assessmentData.foreWrinkleValue) / 3;
    if (wrinkles <= 33) {
        assessmentData.LW += 1;
    }
    if (wrinkles > 33 && wrinkles <= 66) {
        assessmentData.LW += 2;
    }
    if (wrinkles > 66) {
        assessmentData.LW += 3;
    }
    if (assessmentData.skinSomeFirm) {
        assessmentData.LW += 4;
    }
    if (assessmentData.skinSomeSag) {
        assessmentData.LW += 8;
    }
    if (assessmentData.skinVerySag) {
        assessmentData.LW += 12;
    }

    if (assessmentData.LW >= 12) {
        assessmentData.LC = "Q8";
    } else if (assessmentData.LW >= 8) {
        assessmentData.LC = "Q6";
    } else {
        assessmentData.LC = "Q5";
    }
}

function calcP(assessmentData) {
    assessmentData.P = 0;
    //CALCULATE PIGMENTATION
    if (assessmentData.age >= 40) {
        assessmentData.P += 1;
    }
    if (assessmentData.ethnicityIndex == 2 || assessmentData.ethnicityIndex == 3 || assessmentData.ethnicityIndex == 6 ||
        assessmentData.ethnicityIndex == 7 || assessmentData.ethnicityIndex == 8 || assessmentData.ethnicityIndex == 9 ||
        assessmentData.ethnicityIndex == 14) {
        assessmentData.P += 2;
    }
    if (assessmentData.environmentTwo) {
        assessmentData.P += 1;
    }
    if (assessmentData.environmentThree || assessmentData.environmentFour) {
        assessmentData.P += 2;
    }
    if (assessmentData.environmentFive || assessmentData.environmentSix || assessmentData.environmentSeven ||
        assessmentData.environmentEight) {
        assessmentData.P += 3;
    }
    if (assessmentData.environmentNine || assessmentData.environmentTen || assessmentData.environmentEleven ||
        assessmentData.environmentTwelve) {
        assessmentData.P += 4;
    }
    if (assessmentData.ageSpotsValue <= 33) {
        assessmentData.P += 1;
    }
    if (assessmentData.ageSpotsValue > 33 && assessmentData.ageSpotsValue <= 66) {
        assessmentData.P += 2;
    }
    if (assessmentData.ageSpotsValue > 66) {
        assessmentData.P += 3;
    }

    if (assessmentData.P >= 6) {
        assessmentData.PC = "X9";
    } else {
        assessmentData.PC = "X4";
    }
}

function calcDM(assessmentData) {
    //Calculate Day Moisturizer
    if (assessmentData.physicalSPFMoisturizer) {
        if (assessmentData.fragranceYes) {
            assessmentData.DM = "T2";
        } else {
            assessmentData.DM = "S2";
        }
    } else {
        if (assessmentData.dayMoisturizer1) {
            if (assessmentData.fragranceYes) {
                assessmentData.DM = "T5";
            } else {
                assessmentData.DM = "S5";
            }
        } else if (assessmentData.dayMoisturizer2) {
            if (assessmentData.fragranceYes) {
                assessmentData.DM = "T6";
            } else {
                assessmentData.DM = "S6";
            }
        } else if (assessmentData.dayMoisturizer3) {
            if (assessmentData.fragranceYes) {
                assessmentData.DM = "T9";
            } else {
                assessmentData.DM = "S9";
            }
        } else if (assessmentData.dayMoisturizer4) {
            if (assessmentData.fragranceYes) {
                assessmentData.DM = "T1";
            } else {
                assessmentData.DM = "S1";
            }
        } else if (assessmentData.dayMoisturizer5) {
            if (assessmentData.fragranceYes) {
                assessmentData.DM = "T7";
            } else {
                assessmentData.DM = "S7";
            }
        } else if (assessmentData.dayMoisturizer6) {
            if (assessmentData.fragranceYes) {
                assessmentData.DM = "T3";
            } else {
                assessmentData.DM = "S3";
            }
        }
    }
}

function calcNM(assessmentData) {
    //Calculate Night Moisturizer
    if (assessmentData.nightMoisturizer1) {
        if (assessmentData.nightFragranceYes) {
            assessmentData.NM = "K5";
        } else {
            assessmentData.NM = "Z5";
        }
    } else if (assessmentData.nightMoisturizer2) {
        if (assessmentData.nightFragranceYes) {
            assessmentData.NM = "K6";
        } else {
            assessmentData.NM = "Z6";
        }
    } else if (assessmentData.nightMoisturizer3) {
        if (assessmentData.nightFragranceYes) {
            assessmentData.NM = "K7";
        } else {
            assessmentData.NM = "Z7";
        }
    } else if (assessmentData.nightMoisturizer4) {
        if (assessmentData.nightFragranceYes) {
            assessmentData.NM = "K8";
        } else {
            assessmentData.NM = "Z8";
        }
    }
}

function calculateCoreCode(assessmentData) {
    var value1 = getCoreDigit1(assessmentData),
        value2 = getCoreDigit2(assessmentData),
        value3 = getCoreDigit3(assessmentData);

    assessmentData.LC = 'Q5';
    assessmentData.S2 = 'R1';
    assessmentData.PC = getCorePc(value1);
    assessmentData.NM = getCoreNm(value1, value2);
    assessmentData.DM = getCoreDm(value1, value2, value3);

    // setCoreLotionCodes(assessmentData, value1, value2, value3);

    return value1 + value2 + value3;
}

function getCorePc(coreCode1) {
    let pc = 'XX';

    if (coreCode1 == '5' || coreCode1 == '4') {
        pc = 'Q5';
    } else if (coreCode1 == '6') {
        pc = 'X4';
    } else if (coreCode1 == '7' || coreCode1 == '8') {
        pc = 'R1'
    }

    return pc;
}

function getCoreNm(coreCode1, coreCode2) {
    let nm = 'XX';

    if (coreCode1 == '4' || coreCode1 == '5') {
        if (coreCode2 == '2' || coreCode2 == '1') {
            nm = 'K8';
        } else if (coreCode2 == '9' || coreCode2 == '3') {
            nm = 'Z8';
        }
    } else if (coreCode1 == '6') {
        if (coreCode2 == '2') {
            nm = 'K7';
        } else if (coreCode2 == '3') {
            nm = 'Z7';
        }
    } else if (coreCode1 == '7') {
        if (coreCode2 == '2') {
            nm = 'K6';
        } else if (coreCode2 == '3') {
            nm = 'Z6';
        }
    } else if (coreCode1 == '8') {
        if (coreCode2 == '2' || coreCode2 == '1') {
            nm = 'K5';
        } else if (coreCode2 == '9' || coreCode2 == '3') {
            nm = 'Z5';
        }
    }

    return nm;
}

function getCoreDm(coreCode1, coreCode2, coreCode3) {
    let dm = 'XX';

    if (coreCode1 == '4') {
        if (coreCode2 == '2' || coreCode2 == '9') {
            dm = 'T1';
        } else if (coreCode2 == '1' || coreCode2 == '3') {
            dm = 'S1';
        }
    } else if (coreCode1 == '5') {
        if (coreCode2 == '2') {
            if (coreCode3 == 'M') {
                dm = 'T3';
            } else if (coreCode3 == 'Y') {
                dm = 'T7';
            }
        } else if (coreCode2 == '3') {
            if (coreCode3 == 'Y') {
                dm = 'S7';
            } else if (coreCode3 == 'M') {
                dm = 'S3';
            }
        }
    } else if (coreCode1 == '6') {
        if (coreCode2 == '2') {
            if (coreCode3 == 'M') {
                dm = 'T1';
            } else if (coreCode3 == 'Y') {
                dm = 'T6';
            }
        } else if (coreCode2 == '3') {
            if (coreCode3 == 'Y') {
                dm = 'S6';
            } else if (coreCode3 == 'M') {
                dm = 'S1';
            }
        }
    } else if (coreCode1 == '7') {
        if (coreCode2 == '2') {
            if (coreCode3 == 'M') {
                dm = 'T9';
            } else if (coreCode3 == 'Y') {
                dm = 'T5';
            }
        } else if (coreCode2 == '3') {
            if (coreCode3 == 'Y') {
                dm = 'S5';
            } else if (coreCode3 == 'M') {
                dm = 'S9';
            }
        }
    } else if (coreCode1 == '8') {
        if (coreCode2 == '2' || coreCode2 == '9') {
            dm = 'T9';
        } else if (coreCode2 == '1' || coreCode2 == '3') {
            dm = 'S9';
        }
    }

    return dm;
}

function getCoreDigit1(assessmentData) {
    let value = 'X';

    if (assessmentData.skinVeryDry) {
        value = '4';
    } else if (assessmentData.skinDry) {
        value = '5';
    } else if (assessmentData.skinNormal || assessmentData.skinCombination) {
        value = '6';
    } else if (assessmentData.skinOily) {
        value = '7';
    } else if (assessmentData.skinVeryOily) {
        value = '8';
    }

    return value;
}

function getCoreDigit2(assessmentData) {
    let value = 'X';

    if (assessmentData.fragranceYes && assessmentData.nightFragranceYes) {
        value = '2';
    } else if (assessmentData.fragranceNo && assessmentData.nightFragranceYes) {
        value = '1';
    } else if (assessmentData.fragranceYes && assessmentData.nightFragranceNo) {
        value = '9';
    } else if (assessmentData.fragranceNo && assessmentData.nightFragranceNo) {
        value = '3';
    }

    return value;
}

function getCoreDigit3(assessmentData) {
    let value = 'X';

    if (assessmentData.spfYes) {
        value = 'M';
    } else if (assessmentData.spfNo) {
        value = 'Y';
    }

    return value;
}

let coreCode1 = ['4', '5', '6', '7', '8'];     // place 1 possible values of code.  indexes into coreDM2, coreNM2, and coreSerum2
let coreDM2 = ['1', '37', '16', '95', '9'];     // possible values for DM digit
let coreNM2 = ['8', '8', '7', '6', '5'];     // possible values for NM digit
let coreSerum2 = ['Q5', 'Q5', 'X4', 'R1', 'R1'];    // possible pc serums

let coreCode2 = ['1', '2', '3', '9'];   // place 2 possible values of core code.  indexes into coreDM1 and coreNM1
let coreDM1 = ['S', 'T', 'S', 'T'];   // possible values for DM alpha
let coreNM1 = ['K', 'K', 'Z', 'Z'];   // possible values for NM alpha

let coreCode3 = ['M', 'Y']; // place 3 possible values of core code.  used to index into coreDM2 individual values

function decodeCoreCode(coreCode) {
    let code1Idx, code2Idx, code3idx,
        retArray = [],
        day, night, pc;

    if (coreCode.length === 3) {
        code1Idx = coreCode1.indexOf(coreCode.charAt(0));
        code2Idx = coreCode2.indexOf(coreCode.charAt(1));
        code3idx = coreCode3.indexOf(coreCode.charAt(2));

        if (checkCoreSequence(code1Idx, code2Idx, code3idx)) {
            day = decodeCoreDay(code1Idx, code2Idx, code3idx);
            night = decodeCoreNight(code1Idx, code2Idx);
            pc = decodeS2(code1Idx);

            if (day && night && pc) {
                retArray.push(day);
                retArray.push(night);
                retArray.push('Q5');
                retArray.push(pc);
                retArray.push('R1');
            }
        }
    }
    return retArray;
}

function decodeCoreDay(code1Idx, code2Idx, code3Idx) {
    let retVal = null;

    if (code1Idx >= 0 && code2Idx >= 0 && code3Idx >= 0) {
        retVal = coreDM1[code2Idx] + coreDM2[code1Idx].substr(code3Idx, 1);
    }

    return retVal;
}

function decodeCoreNight(code1Idx, code2Idx) {
    let retVal = null;

    if (code1Idx >= 0 && code2Idx >= 0) {
        retVal = coreNM1[code2Idx] + coreNM2[code1Idx];
    }

    return retVal;
}

function decodeS2(code1Idx) {
    let retVal = null;

    if (code1Idx >= 0) {
        retVal = coreSerum2[code1Idx];
    }

    return retVal;
}

function checkCoreSequence(code1Idx, code2Idx, code3Idx) {
    let checkedOut = true;

    if ((code1Idx < 0 || code2Idx < 0 || code3Idx < 0) ||
        ((code2Idx === 0 || code2Idx === 3) && !(code1Idx === 0 || code1Idx === 4)) ||
        (code3Idx === 1 && (code1Idx === 0 || code1Idx === 4))) {

        checkedOut = false;
    }

    return checkedOut;
}

function getCodesMap() {
    let agelocme = ConfigService.getMarketConfig().agelocme,
        codesMap = agelocme.codesMap || {};

    if (agelocme.showCoreSolutions && agelocme.codeMappings && !agelocme.codesMap) {
        if (typeof agelocme.codeMappings == 'string') {
            agelocme.codeMappings = [agelocme.codeMappings];
        }
        agelocme.codeMappings.map(function (codeMapping) {
            let codeMap = JSON.parse(codeMapping);

            codesMap[codeMap.fromCode] = codeMap.toCode;
        });
        agelocme.codesMap = codesMap;
    }
    return codesMap;
}

function isRetiredCode(code) {
    var mappedCode = getCodesMap()[code];
    return typeof mappedCode === 'string' && mappedCode.length > 0;
}

function codesSameType(code1, code2) {
    return code1.length == code2.length && validCode(code1) && validCode(code2);
}

async function addAssesment(user, products) {
    let data;
    let response = [];
    const headers = {
        'client_id': ConfigService.getMarketConfig().checkout.clientId,
        'Authorization': `JWT ${user.eid}`
    };
    const url = `${ConfigService.getMarketConfig().awsUrl}/ns-share-api/v1/connect/user/${user.id}/agelocme`;
    if (products.length > 0) {
        for (let i = 0; i < products.length; i++) {
            if(products[i].agelocme){
                data = products[i].agelocme
                let agelocMeData = await axios({url, method: 'POST', data, headers });
                response.push(agelocMeData.body);
            }
        }
    }
    return response;
    
}

async function addAssesmentLegacy(user, products) {
    let data;
    let response = [];
    const headers = {
        'client_id': ConfigService.getMarketConfig().checkout.clientId,
        'Authorization': `JWT ${user.eid}`
    };
    const url = `${ConfigService.getMarketConfig().awsUrl}/ns-share-api/v0/connect/user/${user.id}/agelocme`;
    if (products.length > 0) {
        for (let i = 0; i < products.length; i++) {
            if(products[i].agelocme){
                data = products[i].agelocme
                let agelocMeData = await axios({url, method: 'POST', data, headers });
                response.push(agelocMeData.body);
            }
        }
    }
    return response;
    
}

async function getAssessments (user) {
    const headers = {
        'client_id': ConfigService.getMarketConfig().checkout.clientId
    };
    const response = await axios({
        url: `${ConfigService.getMarketConfig().awsUrl}/ns-share-api/v1/connect/user/${user.id}/agelocme`,
        method: 'GET',
        headers
    });

    return response.body;
}

async function getAssessmentsLegacy (user) {
    const headers = {
        'client_id': ConfigService.getMarketConfig().checkout.clientId
    };
    const response = await axios({
        url: `${ConfigService.getMarketConfig().awsUrl}/ns-share-api/v0/connect/user/${user.id}/agelocme`,
        method: 'GET',
        headers
    });

    return response.body;
}

async function getAssessment (user, assessmentId) {
    const headers = {
        'client_id': ConfigService.getMarketConfig().checkout.clientId
    };
    const response = await axios({
        url: `${ConfigService.getMarketConfig().awsUrl}/ns-share-api/v1/connect/user/${user.id}/agelocme/${assessmentId}`,
        method: 'GET',
        headers
    });

    return response.body;
}

export default {
    validCode: validCode,
    decodeCode: decodeCode,
    calculateCode: calculateCode,
    codesSameType: codesSameType,
    addAssesment: addAssesment,
    addAssesmentLegacy: addAssesmentLegacy,
    getAssessments: getAssessments,
    getAssessment: getAssessment,
    getAssessmentsLegacy: getAssessmentsLegacy
}
